// @purpose GLUE
// Bootstrap: htmx (+ SSE extension) and Alpine with the global tray + toast stores (S5.4).
import "./htmx.js";
import "./errors.js";
import "htmx-ext-sse";
// Boosted navigation swaps only <body>; head-support merges the new page's <head>, so its CSS page
// bundle (CSS split, {% page_css %}) loads too. Without it, cross-bundle links render unstyled.
import "htmx-ext-head-support";
import Alpine from "alpinejs";
import { quadGroup } from "./ui/quad.js";
import { initDialogs } from "./ui/dialog.js";
import { initButtonStates } from "./ui/button.js";
import { initAnchors } from "./ui/anchors.js";
import { initMenus } from "./ui/menu.js";
import { initDisclose, initRails } from "./ui/disclose.js";
import { initDaylight } from "./ui/daylight.js";
import { initTabbar } from "./ui/tabbar.js";
import { initJourneys } from "./ui/journeys.js";
import { initTapShield } from "./ui/tapshield.js";
import { initKeep } from "./ui/keep.js";

let seq = 0;

Alpine.store("tray", {
  jobs: [],
  upsert(job) {
    const i = this.jobs.findIndex((j) => j.id === job.id);
    if (i === -1) this.jobs.push(job);
    else this.jobs[i] = { ...this.jobs[i], ...job };
    if (job.pct >= 100) setTimeout(() => this.remove(job.id), 1200);
  },
  remove(id) {
    this.jobs = this.jobs.filter((j) => j.id !== id);
  },
});

Alpine.store("toasts", {
  items: [],
  push(text, kind = "info", ms = 4000) {
    const id = ++seq;
    this.items.push({ id, text, kind });
    setTimeout(() => (this.items = this.items.filter((t) => t.id !== id)), ms);
  },
});

// quad_option (M1.3): `x-data="quadGroup()"` is written inline in templates, so it must resolve
// against the global scope Alpine evaluates against.
window.quadGroup = quadGroup;

initDialogs();
initButtonStates();
initAnchors(); // scroll to #fragment / top + focus after boosted navigation
initMenus(); // header account menu: outside tap / Esc / link closes it
initDisclose(); // #links into a closed <details> open it first
initRails(); // the home's section strip marks the section in view
initDaylight(); // Daylight hero: send one message to three specimens
initTabbar(); // the mobile tab bar tucks away while reading down
initTapShield(); // quiz swaps: stray taps on links outside the quiz are ignored for a moment
initKeep(); // "Keep this result on every device": send the link once after sign-in
initJourneys(); // nav, quiz-board and thanks events (docs/design/JOURNEYS.md §4)
document.addEventListener("htmx:afterSettle", initRails);

window.Alpine = Alpine;
Alpine.start();
